module.exports = __webpack_public_path__ + "img/aniversariantesdodia.a82875fe.png";